var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SpFinder',{ref:"finder",attrs:{"row-key":"device_id","split-count":10,"url":_vm.table_url,"setting":_vm.setting,"fixed-row-action":"","reserve-selection":"","hooks":{
      beforeSearch: _vm.beforeSearch
    }}}),_c('ImportDialog',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"importDialog",attrs:{"buttonName":"导入","buttonSize":"medium","fileName":"导入设备模版","fileType":"upload_devices"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }